module.exports = __webpack_public_path__ + "img/logo.e7d043ce.png";